import appConfig from '../appConfig';
import {config} from '../config';
import {TConfigGetterReturn} from './types';

const isStandaloneMarket = () => {
    const isRef = process.env.REACT_APP_IS_BUILD_REF === 'true';

    return !isRef || appConfig.getIsMonolith();
};

export default {
    getIsDCS: (): TConfigGetterReturn<boolean> => config.data.market.dcs.isDCS,
    getIsDCE1: (): TConfigGetterReturn<boolean> => config.data.market.dce1.isDCE1,
    getIsDCE2: (): TConfigGetterReturn<boolean> => config.data.market.dce2.isDCE2,
    getIsMonolith: (): TConfigGetterReturn<boolean> => config.data.market.monolith?.isMonolith,
    isStandaloneMarket: (): TConfigGetterReturn<boolean> => isStandaloneMarket(),
};
